import * as http from 'utils/http';
import config from 'config';

export const fetcher = (url) => http.get(`${config.BASE_URL}${url}`);
export const getTasks = (query) => `/api/dms/documents/?${query}`;
export const getTaskDetail = (docId) => http.get(`${config.BASE_URL}/api/dms/documents/${docId}/`);
export const getDocumentTypes = () => http.get(`${config.BASE_URL}/api/dms/document_types/`);
export const postValidateDocument = ({
  docId,
  expiration_date,
  iban_number,
  insurance_coverage_amount,
  docTypeId,
  uuid,
  workflow,
  document_type_name,
  notify_carrier,
  entity_type,
  entity_uuid,
}) =>
  http.post(`${config.BASE_URL}/api/dms/document/${docId}/validate/`, {
    expiration_date,
    iban_number,
    insurance_coverage_amount,
    document_type: docTypeId,
    uuid,
    workflow,
    document_type_name,
    notify_carrier,
    entity_type,
    entity_uuid,
  });

export const postRejectDocument = ({
  docId,
  rejectReason,
  docType,
  uuid,
  document_type_name,
  notify_carrier,
  entity_type,
  entity_uuid,
}) =>
  http.post(`${config.BASE_URL}/api/dms/document/${docId}/reject/`, {
    comment: rejectReason,
    document_type: docType,
    document_type_name,
    uuid,
    notify_carrier,
    entity_type,
    entity_uuid,
  });
export const postCreateCarrier = (carrier) =>
  http.post(`${config.BASE_URL}/api/mercury/documentation/carrier/`, carrier);
export const postAssignDocument = ({ docId, carrier_uuid, owner }) =>
  http.post(`${config.BASE_URL}/api/dms/document/${docId}/assign/`, {
    carrier_uuid,
    owner,
  });
